module.exports = "/static/media/lineto-circular-bookItalic.96286d95.woff";